<template>
  <CellValue :user-has-read-access="readable" :user-has-update-access="false" cell-value="">
    <template v-if="isJiraIssueOrWorkItem">
      <AppTag
        :id="`st${uid}`"
        :content="item.jiraStatus"
        :content-background="resolvedJiraStatusColor.background"
        :content-color="resolvedJiraStatusColor.text"
      />
    </template>

    <template v-else>
      <CheckinModalTrigger
        v-if="clickable"
        :entry-point="CHECKIN_MODAL_ENTRY_POINTS.CREATE"
        :okr-element="item"
        @open-checkin-modal="$emit('open-checkin-modal', $event)"
      >
        <template #default="{ onTriggerClick, triggerStyles }">
          <ObjectiveStatus :status="status" :style="triggerStyles" @click="onTriggerClick" />
        </template>
      </CheckinModalTrigger>

      <ObjectiveStatus v-else :status="status" />
    </template>
  </CellValue>
</template>

<script>
import { defineComponent } from 'vue'

import { CHECKIN_MODAL_ENTRY_POINTS } from '@/utils/check-ins/check-ins'
import { isJiraIssueOrWorkItem } from '@/utils/objective-types'
import { calculateObjectiveStatus } from '@/utils/objectives'
import { uid } from '@/utils/uid'

import CheckinModalTrigger from '@/components/objectives/element-check-in/CheckinModalTrigger'
import ObjectiveStatus from '@/components/objectives/ObjectiveStatus'
import CellValue from '@/components/objectives/table/cells/CellValue'
import AppTag from '@/components/ui/AppTag/AppTag'

export default defineComponent({
  name: 'StatusCell',

  components: {
    CheckinModalTrigger,
    AppTag,
    CellValue,
    ObjectiveStatus
  },

  props: {
    item: {
      type: Object,
      required: true
    },

    readable: {
      type: Boolean
    },

    clickable: {
      type: Boolean,
      default: true
    }
  },

  emits: {
    'open-checkin-modal': null
  },

  data() {
    return {
      uid: uid()
    }
  },

  computed: {
    CHECKIN_MODAL_ENTRY_POINTS: () => CHECKIN_MODAL_ENTRY_POINTS,

    isJiraIssueOrWorkItem() {
      return isJiraIssueOrWorkItem(this.item)
    },

    resolvedJiraStatusColor() {
      return {
        background: this.item.jiraStatusColor?.background || '#dfe1e6',
        text: this.item.jiraStatusColor?.text || '#42526e'
      }
    },

    status() {
      return calculateObjectiveStatus(
        this.item.confidenceLevelId,
        this.item.automaticConfidenceLevelId
      )
    }
  }
})
</script>
